import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

// Import Fire Safety images
import extinguishersImage from '../assets/images/services/fire/EXTINGUISHERS.jpg';
import fireHydrantImage from '../assets/images/services/fire/FIRE HYDRANT AND SPRINKLER SYSTEMS.jpg';
import fireSuppressionImage from '../assets/images/services/fire/FIRE SUPPRESSION SYSTEMS.jpg';
import signageImage from '../assets/images/services/fire/SIGNAGE AND WEARABLE SAFETY EQUIPMENT.jpg';
import vehicleSuppressionImage from '../assets/images/services/fire/VEHICLE SUPPRESSION SYSTEMS.jpg';
import fireTrainingImage from '../assets/images/services/fire/FIRE SAFETY TRAINING.jpg';

// Import Fire Safety video
import fireVideo from '../assets/videos/services/FIRE.mp4';

// Import Fire Safety benefits image
import fireBenefitsImage from '../assets/images/services/fire/FIRE DETECTION AND ALARM SYSTEMS.jpg';

const FireSafetyPage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO title="Fire Safety Solutions" description="Professional fire safety solutions in DRC: extinguishers, sprinkler systems, fire suppression, vehicle suppression, and safety training by Cool & Care." keywords="fire safety DRC, fire extinguishers, sprinkler systems, fire suppression, fire safety training Kinshasa" />
      <ServiceSchema name="Fire Safety Solutions" description="Professional fire safety solutions including extinguishers, sprinkler systems, fire suppression, and safety training." url="/fire-safety" />
      <BreadcrumbSchema items={[{ name: 'Services', url: '/services' }, { name: 'Fire Safety', url: '/fire-safety' }]} />
      <ServicePage
        serviceName={t('servicePage.services.fireSafety.name')}
      serviceDescription={t('servicePage.services.fireSafety.description')}
      videoUrl={fireVideo}
      productImages={[
        extinguishersImage,
        fireHydrantImage,
        fireSuppressionImage,
        signageImage,
        vehicleSuppressionImage,
        fireTrainingImage
      ]}
      features={t('servicePage.services.fireSafety.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.fireSafety.benefits', { returnObjects: true }) as string[]}
      benefitsImage={fireBenefitsImage}
    />
    </>
  );
};

export default FireSafetyPage;
